import React from "react";
import { Backdrop, Stack, Typography } from "@mui/material";
import { motion } from "framer-motion";
import CustomProgress from "../../Components/CustomProgress";

const sentence = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.05 },
  },
};

const letter = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0 },
};  const dots = [0, 0.2, 0.4, 0.6, 0.8];

export default function LoaderBackdrop({
  open,
  text,
}: {
  open: boolean;
  text?: string;
}) {
  const displayText = text ?? "Loading...";

  return (
    <Backdrop
      open={open}
      sx={{
        color: "#fff",
        zIndex: 9999999,
        backdropFilter: "blur(3px)",
      }}
    >
      {open && (
        <Stack spacing={2} alignItems="center" justifyContent="center">
          {/* Progress Animation */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          >
            <CustomProgress
              sx={{
                height: 60,
                width: 60,
                color: "white",
              }}
            />
          </motion.div>

          {/* Text Animation (character by character) */}
          {/* <motion.div
            variants={sentence}
            initial="hidden"
            animate="visible"
            style={{ display: "flex", gap: "2px" }}
          >
            {displayText.split("").map((char, index) => (
              <motion.span key={index} variants={letter}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 500, color: "white", letterSpacing: 0.5 }}
                >
                  {char}
                </Typography>
              </motion.span>
            ))}
          </motion.div> */}
          <motion.div
  animate={{ opacity: [0, 1, 0] }}
  transition={{ duration: 1, repeat: Infinity }}
>
  <Typography
    variant="h6"
    sx={{ fontWeight: 500, color: "white", letterSpacing: 0.5 }}
  >
    {text ?? "Loading"}  {dots.map((delay, index) => (
          <motion.span
            key={index}
            animate={{ opacity: [0, 1, 0] }}
            transition={{
              duration: 1.2,
              repeat: Infinity,
              delay,
            }}
          >
            .
          </motion.span>
        ))}
  </Typography>
</motion.div>
        </Stack>
      )}
    </Backdrop>
  );
}
